import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { AdminSubmissionDetail } from "./types";

// GET /api/admin/submissions/:id
//
// Drawer payload. 404 propagates as an ApiClientError with `.status === 404`.
// Disabled when `id` is null so the hook can mount unconditionally on the
// queue page without firing a request until the URL carries `?submission=`.
export function useAdminSubmission(id: string | null) {
  return useQuery<AdminSubmissionDetail, ApiClientError>({
    enabled: !!id,
    queryKey: id
      ? queryKeys.submissions.detail(id)
      : queryKeys.submissions.detail("__pending__"),
    queryFn: async () => {
      if (!id) throw new Error("submission id required");
      return apiFetch<AdminSubmissionDetail>(
        `/admin/submissions/${encodeURIComponent(id)}`,
      );
    },
  });
}
